import React from 'react';
import Button from '@mui/material/Button';
import ColumnBox from 'components/ColumnBox';
import AddCircle from '@mui/icons-material/AddCircle';
import Restore from '@mui/icons-material/Restore';
import Person from '@mui/icons-material/Person';
import Beenhere from '@mui/icons-material/Beenhere';

import { useNavigate } from 'react-router-dom';

import BigHeading from 'components/BigHeading';

export default function Form() {
    const navigate = useNavigate();

    const goToNewTraining = function() {
        navigate({ "pathname": "session_detail" })
    }
    const goToPrevTrainings = function() {
        navigate({ "pathname": "previous_sessions" })
    }
    const goToEmployeeList = function() {
        navigate({ "pathname": "employee_list" })
    }
    const goToTopicList = function() {
        navigate({ "pathname": "topic_list" })
    }

    return (
        <ColumnBox sx={{ alignItems: 'center' }}>
            <BigHeading>Training Index</BigHeading>
            <Button sx={{ marginTop: '15px' }} variant="outlined"
                onClick={() => { goToNewTraining() }} startIcon={ <AddCircle /> }>
                Record New Session
            </Button>
            <Button sx={{ marginTop: '15px' }} variant="outlined" size="small"
                onClick={() => { goToPrevTrainings() }} startIcon={<Restore />}>
                Previous Sessions
            </Button>
            <Button sx={{ marginTop: '15px' }} variant="outlined" size="small"
                onClick={() => { goToEmployeeList() }} startIcon={<Person />}>
                Members
            </Button>
            <Button sx={{ marginTop: '15px' }} variant="outlined" size="small"
                onClick={() => { goToTopicList() }} startIcon={<Beenhere />}>
                Topics
            </Button>
        </ColumnBox>
    );
}
